import React from 'react';
import {
    LayoutDashboard,
    Landmark,
    AlertTriangle,
    ShieldCheck,
    Activity,
    Siren,
    ClipboardCheck,
    BadgeCheck,
    Wrench
} from 'lucide-react';

interface CSuiteSidebarProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
    isOpen: boolean;
}

const CSuiteSidebarV2: React.FC<CSuiteSidebarProps> = ({ activeTab, onTabChange, isOpen }) => {
    const menuItems = [
        { id: 'dashboard', label: 'Overview', icon: <LayoutDashboard size={20} /> },
        { id: 'governance', label: 'Governance', icon: <Landmark size={20} /> },
        { id: 'risk', label: 'Risks', icon: <AlertTriangle size={20} /> },
        { id: 'internal-controls', label: 'Controls', icon: <ShieldCheck size={20} /> },
        { id: 'compliances', label: 'Compliances', icon: <ClipboardCheck size={20} /> },
        { id: 'audits', label: 'Audits', icon: <BadgeCheck size={20} /> },
        { id: 'monitoring', label: 'Monitoring', icon: <Activity size={20} /> },
        { id: 'incidence-reporting', label: 'Incidents', icon: <Siren size={20} /> },
        { id: 'capa', label: 'CAPA', icon: <Wrench size={20} /> },
    ];

    return (
        <div className={`c-suite-sidebar ${isOpen ? 'expanded' : 'collapsed'}`}>
            <nav className="c-suite-sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        data-testid={`NAV_leadership_sidebar_${item.id}`}
                        className={`c-suite-nav-item ${activeTab === item.id ? 'active' : ''}`}
                        onClick={() => onTabChange(item.id)}
                        title={!isOpen ? item.label : undefined}
                    >
                        <span className="c-suite-nav-icon">{item.icon}</span>
                        {isOpen && <span className="c-suite-nav-label">{item.label}</span>}
                    </button>
                ))}
            </nav>
            {isOpen && (
                <div className="p-4 text-xs text-gray-400 text-center border-t border-white/10 mt-auto">
                    v2.1 - FORCED
                </div>
            )}
        </div>
    );
};

export default CSuiteSidebarV2;
